export const UPDATE_APP_SIDEBAR_SHOW = 'UPDATE_APP_SIDEBAR_SHOW'
export const UPDATE_LOOKUP_DATA = 'UPDATE_LOOKUP_DATA'
